// extracted by mini-css-extract-plugin
module.exports = {"container":"NewVersionAvailable_container__3KecE","link":"NewVersionAvailable_link__2FAQI"};